import { Grid } from 'antd';

/**
 * Whether the annotation toolbar shows its buttons as icons only. Below antd's
 * `xl` breakpoint (1200px) the full labels do not fit the toolbar's single row;
 * the labels and shortcuts stay in the tooltips and accessible names.
 */
export const useCompactToolbar = () => {
	const screens = Grid.useBreakpoint();
	return !screens.xl;
};

/**
 * Whether the toolbar has room for the labels of its secondary buttons (Delete):
 * from antd's `xxl` breakpoint (1600px). Between `xl` and `xxl` (a 13-inch
 * laptop) they show as icons, with the label in the tooltip and accessible name.
 */
export const useWideToolbar = () => {
	const screens = Grid.useBreakpoint();
	return Boolean(screens.xxl);
};
